<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: "UiSimplebar" });
</script>
<template>
    <div class="ui-simplebar" :class="define.trigger == 'Hover' ? 'ui-simplebar-hover' : ''">
        <!-- * 轨道 -->
        <div class="ui-simplebar-slideway" ref="slideway" v-if="visible" @mousedown.self="methods.move">
            <div class="ui-simplebar-bar" v-bind="binds.bar" @mousedown="methods.drag"></div>
        </div>

        <!-- * 内容 -->
        <div class="ui-simplebar-container" ref="container" v-bind="binds.container">
            <div class="ui-simplebar-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件属性
import { nextTick, onBeforeUnmount, onMounted } from "vue";
import { UiSimplebarEmits, UiSimplebarPropsOption } from "./src/component";
import { useComposable } from "./src/composable";

//* 组件属性注册
const emits = defineEmits(UiSimplebarEmits);
const define = defineProps(UiSimplebarPropsOption);

//* 组合函数
const { refs, vars, nodes, binds, methods } = useComposable(define, emits);
const { slideway, container } = nodes;
const { visible } = refs;

//* 移动函数
const move = (top: number) => {
    nextTick(() => {
        container.value?.scrollTo({ top: top, behavior: "smooth" });
    });
};

//* 组件卸载注销观察者
onBeforeUnmount(() => vars.observer?.disconnect());
//* 组件挂载注册观察者
onMounted(() => {
    const node = container.value?.querySelector(".ui-simplebar-content");
    if (node) {
        vars.observer = new ResizeObserver(() => methods.init());
        vars.observer.observe(node);
    }
});

//* 组件属性导出
;
defineExpose({ move });
</script>
